import { forwardRef, useImperativeHandle, useRef } from "react";
import CardDraggable from "../CardDraggable";
import classes from "./deck.module.scss";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { CONTENT_TYPE } from "@educaplay/core";

const DeckCards = forwardRef( function DeckCards({ onAnswer }, ref) {
  const questions = useSelector(state => state.game.questions).map(question => {
    return {
      ...question,
      imgSrc: question.media?.type === CONTENT_TYPE.IMAGE ? question.media.src : null,
      audioSrc: question.media?.type === CONTENT_TYPE.AUDIO ? question.media.src : null,
    }
  });
  const currentIndex = useSelector(state => state.game.currentIndex);

  const current = questions[currentIndex];
  const next = questions[currentIndex + 1] ?? null;
  const currentCardRef = useRef(null);

  useImperativeHandle(ref, () => ({
    fail: async() => {
      await currentCardRef.current?.fail();
    }
  }));

  return (
    <div className={classes.deck}>
        {next && (
          <CardDraggable key={`next-${next.id}`} onAnswer={onAnswer} onAnswerEnd={() => {}} text={next.text} imgSrc={next.imgSrc} audioSrc={next.audioSrc} isNextCard />
        )}
        {current && (
          <CardDraggable ref={currentCardRef} key={`current-${current.id}`} onAnswer={onAnswer} onAnswerEnd={() => {}} text={current.text} imgSrc={current.imgSrc} audioSrc={current.audioSrc} />
        )}
    </div>
  );
});

export default DeckCards;

DeckCards.propTypes = {
  onAnswer: PropTypes.func.isRequired,
  questions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    text: PropTypes.string,
    imgSrc: PropTypes.string,
    audioSrc: PropTypes.string,
  })).isRequired
}